import { useLocale } from '../contexts/index.js'
import { SOURCE_REPO_URL } from '../Utils.js'
import { Octicon } from './index.js'

interface Props {
	donate?: boolean,
}
export function Footer({ donate }: Props) {
	const { locale } = useLocale()

	// ULICRAFT FORK — upstream's README asks forks to change this footer and,
	// preferably, to keep a note that the fork is based on Misode's work. The
	// credit and the donate link below are kept deliberately: this is his
	// project, we only pinned it and made it work without internet.
	//
	// These are plain links, not fetches — they simply do nothing at the party.
	return <footer>
		<p>
			<span>Ulicraft generators — an offline fork of <a href="https://github.com/misode/misode.github.io" target="_blank" rel="noreferrer">Misode's Data Pack Generators</a></span>
		</p>
		<p>
			<span>{locale('developed_by')} <a href="https://github.com/misode" target="_blank" rel="noreferrer">Misode</a></span>
		</p>
		{donate !== false && <p class="donate">
			{Octicon.heart}
			<a href="https://ko-fi.com/misode" target="_blank" rel="noreferrer">{locale('donate')}</a>
		</p>}
		<p>
			{Octicon.mark_github}
			<span>{locale('source_code_on')} <a href={SOURCE_REPO_URL} target="_blank" rel="noreferrer">{locale('github')}</a></span>
		</p>
	</footer>
}
